import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageMalaga = props => {
  return <CityLandingPage cityKey="Malaga" cityConfig={cityContent.malaga} {...props} />;
};

export default LandingPageMalaga;
